export const securitySetup = {
  junior: {
    requirements: [
      { name: 'SSH Key Setup', description: 'Generate and configure SSH keys for Git', priority: 'high' },
      { name: 'Two-Factor Authentication', description: 'Enable 2FA on all development accounts', priority: 'high' },
      { name: 'Environment Variables', description: 'Secure handling of API keys and secrets', priority: 'high' },
      { name: 'HTTPS Configuration', description: 'Ensure all connections use HTTPS', priority: 'medium' }
    ],
    procedures: [
      { step: 'Generate SSH key', command: 'ssh-keygen -t ed25519 -C "your.email@company.com"' },
      { step: 'Add SSH key to agent', command: 'ssh-add ~/.ssh/id_ed25519' },
      { step: 'Create .env file', command: 'touch .env && echo ".env" >> .gitignore' },
      { step: 'Install dotenv', command: 'npm install dotenv' }
    ]
  },
  mid: {
    requirements: [
      { name: 'API Security', description: 'Implement proper API authentication and authorization', priority: 'high' },
      { name: 'Input Validation', description: 'Validate all user inputs on frontend and backend', priority: 'high' },
      { name: 'Security Headers', description: 'Configure security headers for web applications', priority: 'high' },
      { name: 'Dependency Scanning', description: 'Regular security audits of dependencies', priority: 'medium' }
    ],
    procedures: [
      { step: 'Install helmet.js', command: 'npm install helmet' },
      { step: 'Configure CORS', command: 'npm install cors' },
      { step: 'Set up JWT authentication', command: 'npm install jsonwebtoken' },
      { step: 'Run security audit', command: 'npm audit' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Security Architecture', description: 'Design secure system architecture', priority: 'high' },
      { name: 'Penetration Testing', description: 'Coordinate security testing activities', priority: 'high' },
      { name: 'Compliance Framework', description: 'Ensure compliance with security standards', priority: 'medium' },
      { name: 'Incident Response', description: 'Lead security incident response', priority: 'high' }
    ],
    procedures: [
      { step: 'Configure WAF', command: 'aws wafv2 create-web-acl --name fullstack-waf' },
      { step: 'Set up security monitoring', command: 'helm install falco falcosecurity/falco' },
      { step: 'Enable audit logging', command: 'aws logs create-log-group --log-group-name /aws/lambda/security-audit' },
      { step: 'Configure secret rotation', command: 'aws secretsmanager create-secret --name app-secrets' }
    ]
  }
};
